import { Switch, Tooltip } from "@mantine/core";
import { IconEyeClosed, IconShieldLockFilled } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import { useSessionStore } from "stores/userSessionStore";

// The ModeSelection component is a simple UI element that allows users to toggle between different modes (dark|light).
// It uses the Switch component from Mantine to provide a consistent look and feel.
// This component allows users to select a mode for the application.
// It provides buttons for different modes, which can be styled and customized as needed.
const SwitchSystem = () => {
  const selectedSystem = useSessionStore((s) => s.selectedSystem);
  const { isStaff } = useSessionStore();
  const navigate = useNavigate();

  const handleChange = () => {
    const nextSystem = selectedSystem === "Admin" ? "Default" : "Admin";
    // Delay navigation to ensure state is committed
    setTimeout(() => {
      navigate(nextSystem === "Admin" ? "/admin" : "/");
    }, 0);
  };
  return isStaff ? (
    <Tooltip label="Switch Site" refProp="rootRef">
      <Switch
        styles={{
          track: {
            cursor: "pointer",
          },
          thumb: {
            cursor: "pointer",
          },
        }}
        size="md"
        checked={selectedSystem === "Admin"} // or 'Default' as needed
        onChange={handleChange}
        onLabel={<IconEyeClosed size={16} stroke={2.5} />}
        offLabel={<IconShieldLockFilled size={16} stroke={2.5} />}
      />
    </Tooltip>
  ) : (
    // hide if not admin user
    <></>
  );
};

// This component allows users to select a mode for the application.
// It provides buttons for different modes, which can be styled and customized as needed.
export default SwitchSystem;
